module.exports = __webpack_public_path__ + "fonts/2ed49e17-92ad-4026-9ae6-d20f88f21840.4c907b0e.ttf";